module.exports = __webpack_public_path__ + "static/media/epillax-5.dd49ced5.jpg";